////////////////////////////////////////////////////////////
//     							                                      //
//  Program: CommServedService.js                        //
//  Application: Community served                        //
//  Option: Used for manage amenity type                  //
//  Developer: NP  						                  //
//  Date: 2022-01-11                                      //
//                                                        //
////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

class CommServedService {
  getCommServed(queryString) {
    let endPoint = "communities-served"+ (queryString ? '?' + queryString : '');
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  createCommServed(data) {
    // Delete data which we don't want to send
    delete data.errors;
    delete data.input;

    let endPoint = "communities-served";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }

  getCommServedBySlug(slug) {
    let endPoint = "communities-served/" + slug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  updateCommServed(slug, data) {
    // Delete data which we don't want to send
    delete data.errors;
    delete data.input;

    let endPoint = "communities-served/" + slug;
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.putCall(inputData);
    return response;
  }

  deleteCommServed(slug) {
    let endPoint = "communities-served/" + slug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.deleteCall(inputData);
    return response;
  }
}

export default new CommServedService();
